import BenchmarkRow from './BenchmarkRow'
import { DistributionDotPlot } from '../benchmarkDetails/BenchmarkPositionBlock'
import useCompanyNames from '../../hooks/useCompanyNames'

/**
 * Benchmark van het effect van dit thema: of er over het effect als geheel
 * genoeg vergelijkingsbasis is om er iets over te beweren.
 *
 * Altijd effectbreed: de benchmark is (nog) niet per doelgroep gescoped, dus
 * dit zegt iets over álle doelgroepen op dit effect. Het label dat dat zei is
 * op verzoek weggehaald (user 2026-10-12).
 *
 * Drie toestanden uit elkaar; 'geen benchmark' is geen oordeel over sterkte.
 * AI-CONTEXT: See docs/pitfalls.md#ui-empty-state-claims-absence-while-loading
 *
 * @param {object} props
 * @param {{row: (object|null), positioning?: (object|null), benchmarkGrowth?: (number|null), loading: boolean, loaded: boolean, error: (Error|null)}} props.benchmark - Uit useEffectBenchmark
 */
const ThemeBenchmarkSection = ({ benchmark }) => {
    // Het themadetail is alleen voor het beheerteam (de pagina gaat zichzelf
    // op isSuperAdminTenant, en msiBenchmark stuurt de ids alleen in de
    // beheerweergave mee): daarom de echte namen in de scatterplot.
    const companyNames = useCompanyNames(
        ((benchmark.positioning && benchmark.positioning.distribution) || []).map((r) => r.companyId),
    )
    const inhoud = () => {
        if (benchmark.error) {
            return (
                <p className="intelligence-state intelligence-state--error">
                    De benchmark kon niet worden geladen: {benchmark.error.message}
                </p>
            )
        }
        if (!benchmark.loaded) return <p className="intelligence-state">Benchmark laden…</p>
        const row = benchmark.row
        if (!row) return <p className="intelligence-state">Er is geen benchmark voor dit effect.</p>
        return (
            <>
                <div className="intelligence-agenda-list">
                    <BenchmarkRow row={row} />
                </div>
                {/* De organisaties in de benchmark, uit dezelfde aanroep. */}
                {benchmark.positioning && (
                    <DistributionDotPlot
                        positioning={benchmark.positioning}
                        benchmarkGrowth={benchmark.benchmarkGrowth}
                        companyNames={companyNames}
                    />
                )}
            </>
        )
    }

    return (
        <section className="intelligence-panel">
            <h3 className="intelligence-panel__title">Benchmark</h3>
            {inhoud()}
        </section>
    )
}

export default ThemeBenchmarkSection
